module.exports = __webpack_public_path__ + "img/template-03.aa51544c.jpg";